module.exports = __webpack_public_path__ + "static/media/item_20_2_comp.b01750ea.png";